import { useContext, useEffect, useState } from 'react';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { CanView } from 'components/Can';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { ExportPageData } from 'components/ExportPageData';
import { FilterTags } from 'components/FilterTags';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { Paginator } from 'primereact/paginator';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SplitButton } from 'primereact/splitbutton';
import { Tag } from 'primereact/tag';
import { Title } from 'components/Title';
import FuncionariosAddPage from 'pages/funcionarios/Add';
import useApp from 'hooks/useApp';
import useUtils from 'hooks/useUtils';
import useListPage from 'hooks/useListPage';
import FuncionariosEditPage from './Edit';
import ResetPassword from 'pages/index/ResetPassword';
import { LockedFrag } from "components/Fragments/ComponentsFrag";
import StatusBarIcons from "components/StatusBardIcons";
import apiUtils from 'api/apiUtils';
import useModulePermissions from 'hooks/useModulePermissions';
import ConsultaPedidosModal from './ConsultaPedidosModal';
import './Funcionarios.css';

const Funcionarios = (props) => {
	const app = useApp();
	const utils = useUtils();
	const { empid, setempid } = useApp();
	const apiUtil = apiUtils();
	const { permissions, error } = useModulePermissions('funcionarios');

	// Estado para o Modal de Consulta de Pedidos
	const [selectedFuncionarioConsulta, setSelectedFuncionarioConsulta] = useState(null);
	const [isConsultaDialogVisible, setIsConsultaDialogVisible] = useState(false);

	const filterSchema = {
		search: {
			tagTitle: "Search",
			value: '',
			valueType: 'single',
			options: [],
		}
	};

	const statusIcons = [
		{ icon: 'pi pi-lock', color: 'yellow', hint: 'Bloqueado' },
		{ icon: 'pi pi-lock-open', color: 'white', hint: 'Liberado' },
	];

	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, selectedItems, apiUrl, sortBy, sortOrder, apiRequestError, setSelectedItems, getPageBreadCrumbs, onSort, deleteItem, pagination } = pageController;
	const { filters, setFilterValue } = filterController;
	const { totalRecords, totalPages, recordsPosition, firstRow, limit, onPageChange } = pagination;

	const handleOpenConsulta = (funcionario) => {
		setSelectedFuncionarioConsulta(funcionario);
		setIsConsultaDialogVisible(true);
	};

	function ActionButton(data) {
		if (!permissions) return null;
		if (!permissions.up && !permissions.de) return null;
		const items = [
			{
				label: "Editar",
				command: (event) => { app.openPageDialog(<FuncionariosEditPage isSubPage apiPath={`/funcionarios/edit/${data.id}`} />, { closeBtn: true }) },
				icon: "pi pi-pencil",
				visible: permissions.up
			},
			{
				label: "Excluir",
				command: (event) => { deleteItem(data.id) },
				icon: "pi pi-trash",
				visible: permissions.de
			},
			{
				label: "Resetar Senha",
				command: (event) => { app.openPageDialog(<ResetPassword id={data.id} tipo="2" title={data.nome} doc={data.matricula} />, { width: "30vw", closeBtn: true }) },
				icon: "pi pi-refresh",
				visible: permissions.up
			}
		];
		return (<SplitButton dropdownIcon="pi pi-bars" className="dropdown-only p-button-text p-button-plain" model={items.filter(item => item.visible !== false)} />);
	}

	// Botão de consulta posicionado antes da impressão
	function bodyConsulta(data) {
		if (!data) return null;
		return (
			<Button
				type="button"
				icon="pi pi-search"
				className="p-button-rounded p-button-text p-button-info"
				tooltip="Consultar pedidos do funcionário"
				tooltipOptions={{ position: "top" }}
				onClick={() => handleOpenConsulta(data)}
			/>
		);
	}

	const OnClickPrintEPI = (param) => {
		if (param) {
			var paramns = { id: 1, filter: `ficha_epi|f_funcid|${param.id}|0|0` };
			app.openPageDialog(<app.PrintPreview paramns={paramns} />, { maximized: true, closeBtn: true, width: '80vw' });
		}
	};

	function bodyPrintFichaEPI(data) {
		if (data && data.hasepis) {
			return (
				<app.PrintButton onClick={() => OnClickPrintEPI(data)} />
			);
		}
		return null;
	}

	const OnClickPrintFicha = (param) => {
		if (param) {
			var paramns = { id: 3, filter: `funcionarios|id|${param.id}|0|0` };
			app.openPageDialog(<app.PrintPreview paramns={paramns} />, { maximized: true, closeBtn: true, width: '80vw' });
		}
	};

	function bodylatePrintFicha(data) {
		if (data) {
			return (
				<app.PrintButton onClick={() => OnClickPrintFicha(data)} />
			);
		}
		return null;
	}

	function PageLoading() {
		if (loading) {
			return (
				<div className="flex align-items-center justify-content-center text-gray-500 p-3">
					<div><ProgressSpinner style={{ width: '50px', height: '50px' }} /> </div>
					<div className="font-bold text-lg">Carregando...</div>
				</div>
			);
		}
		return null;
	}

	function EmptyRecordMessage() {
		if (pageReady && !records.length) {
			return (
				<div className="flex flex-column align-items-center justify-content-center p-5 text-gray-500 text-center">
					<i className="pi pi-users text-4xl mb-2 text-primary" style={{ opacity: 0.6 }} />
					<div className="text-lg font-bold text-700">Nenhum Funcionário Encontrado</div>
					<div className="text-sm text-500 mt-1">Verifique o termo pesquisado ou cadastre um novo funcionário.</div>
				</div>
			);
		}
		return null;
	}

	function MultiDelete() {
		if (selectedItems.length) {
			return (
				<div className="m-2 flex-grow-0">
					<Button onClick={() => deleteItem(selectedItems)} icon="pi pi-trash" className="p-button-danger" title="Excluir selecionado" />
				</div>
			);
		}
		return null;
	}

	function ExportData() {
		if (props.exportData && records.length) {
			const downloadFileName = `${utils.dateNow()}-funcionarios`;
			return (
				<div className="m-2">
					<ExportPageData csv={false} pageUrl={apiUrl} downloadFileName={downloadFileName} butonLabel="Exportar" tooltip="Exportar" buttonIcon="pi pi-print" />
				</div>
			);
		}
		return null;
	}

	function PagerControl() {
		if (props.paginate && totalPages > 1) {
			const pagerReportTemplate = {
				layout: pagination.layout,
				CurrentPageReport: (options) => {
					return (
						<span className="text-sm text-gray-500 px-2">Registros <b>{recordsPosition} do {options.totalRecords}</b></span>
					);
				}
			};
			return (
				<div className="flex-grow-1">
					<Paginator first={firstRow} rows={limit} totalRecords={totalRecords} onPageChange={onPageChange} template={pagerReportTemplate} />
				</div>
			);
		}
		return null;
	}

	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
				<MultiDelete />
				<ExportData />
			</div>
		);
	}

	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap align-items-center justify-content-between mt-3 pt-2 border-top-1 surface-border">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
		return null;
	}

	function PageBreadcrumbs() {
		if (props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
		return null;
	}

	if (apiRequestError) {
		return (
			<PageRequestError error={apiRequestError} />
		);
	}

	return (
		<main id="FuncionariosListPage" className="main-page funcionarios-container">
			{props.showHeader && (
				<div className="funcionarios-header-card">
					<div className="flex flex-column md:flex-row align-items-start md:align-items-center justify-content-between gap-3">
						<div className="flex align-items-center gap-2">
							<Title title="Funcionários" titleClass="text-2xl text-primary font-bold m-0" subTitleClass="text-500" separator={false} />
							{totalRecords !== undefined && (
								<Tag
									value={`${totalRecords} ${totalRecords === 1 ? 'registro' : 'registros'}`}
									severity="info"
									className="ml-2"
								/>
							)}
						</div>
						<div className="flex align-items-center gap-2 w-full md:w-auto justify-content-end">
							<Button
								type="button"
								label="Adicionar novo"
								icon="pi pi-plus"
								onClick={() => app.openPageDialog(<FuncionariosAddPage isSubPage apiPath={`/funcionarios/add`} />, { closeBtn: true })}
								className="p-button-primary white-space-nowrap"
								visible={permissions?.cr}
							/>
						</div>
					</div>
				</div>
			)}

			<div className="funcionarios-table-card">
				{/* Toolbar moderna inspirada no GHE */}
				<div className="funcionarios-actions-toolbar">
					<div className="funcionarios-search-full">
						<span className="p-input-icon-left w-full">
							<i className="pi pi-search" />
							<InputText
								placeholder="Pesquisar por nome, apelido, CPF ou matrícula..."
								className="p-inputtext-sm w-full"
								value={filters.search.value}
								onChange={(e) => setFilterValue('search', e.target.value)}
							/>
						</span>
					</div>

					<div className="flex align-items-center gap-2">
						<StatusBarIcons title={"LEGENDA"} icons={statusIcons} />
					</div>
				</div>

				<FilterTags filterController={filterController} />
				<PageBreadcrumbs />

				<div className="page-records">
					<DataTable
						lazy={true}
						loading={loading}
						value={records}
						dataKey="id"
						sortField={sortBy}
						sortOrder={sortOrder}
						onSort={onSort}
						className="p-datatable-sm"
						stripedRows={true}
						showGridlines={false}
						rowHover={true}
						responsiveLayout="stack"
						emptyMessage={<EmptyRecordMessage />}
					>
						{/* Botão de Consulta ANTES da Impressão */}
						<Column
							headerStyle={{ width: '4rem' }}
							headerClass="text-center"
							body={bodyConsulta}
							align={"center"}
							header="Consulta"
						/>
						<Column headerStyle={{ width: '5rem' }} body={bodyPrintFichaEPI} align={"center"} field="ID" header="Ficha EPI" />
						<Column headerStyle={{ minWidth: '14rem' }} field="nome" header="Nome" sortable={true} />
						<Column headerStyle={{ minWidth: '10rem' }} field="apelido" header="Apelido" sortable={true} />
						<Column headerStyle={{ minWidth: '8rem' }} field="matricula" header="Matrícula" sortable={true} align={"center"} className="font-mono text-sm" />
						<Column headerStyle={{ minWidth: '10rem' }} field="cpf" header="CPF" sortable={true} align={"center"} className="font-mono text-sm" />
						<Column headerStyle={{ width: '6rem' }} field="active" header="Status" body={(e) => LockedFrag(e.active)} sortable={true} align={"center"} />
						<Column headerStyle={{ width: '3.5rem' }} headerClass="text-center" body={ActionButton} align={"center"} />
					</DataTable>
				</div>

				<PageFooter />
			</div>

			{/* Modal Popup de Consulta de Pedidos */}
			<ConsultaPedidosModal
				visible={isConsultaDialogVisible}
				onHide={() => setIsConsultaDialogVisible(false)}
				funcionario={selectedFuncionarioConsulta}
			/>
		</main>
	);
};

Funcionarios.defaultProps = {
	primaryKey: 'id',
	pageName: 'funcionarios',
	apiPath: 'funcionarios/index',
	routeName: 'funcionarioslist',
	msgBeforeDelete: "Tem certeza de que deseja excluir este registro?",
	msgTitle: "Apagar registro",
	msgAfterDelete: "Registro excluído com sucesso",
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: true,
	importData: false,
	keepRecords: false,
	multiCheckbox: true,
	search: '',
	fieldName: "",
	fieldValue: "",
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 10,
};

export default Funcionarios;
